import { render, staticRenderFns } from "./resetDone.vue?vue&type=template&id=aa3892f0&scoped=true&"
import script from "./resetDone.vue?vue&type=script&lang=ts&"
export * from "./resetDone.vue?vue&type=script&lang=ts&"
import style0 from "./resetDone.vue?vue&type=style&index=0&id=aa3892f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa3892f0",
  null
  
)

export default component.exports